import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 1138 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1138 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-back\"><defs><style type=\"text/css\"></style></defs><path d=\"M519.127489 210.363006v-170.428257C507.765605-28.236554 450.956186 11.53004 450.956186 11.53004L41.928371 363.748436C-48.966699 426.238797 36.247429 471.686332 36.247429 471.686332l397.665932 346.537455c79.533186 56.809419 85.214128-28.404709 85.214128-28.404709v-159.066373c403.346874-124.980721 568.094188 380.623106 568.094188 380.623106 17.042826 28.404709 22.723768 0 22.723768 0C1274.692759 250.129599 519.127489 210.363006 519.127489 210.363006z m0 0\" p-id=\"2225\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icon/svg/back.svg
// module id = vXXF
// module chunks = 24